// The full Reference Identification Qualifier code list (DE 128) — shared by
// every REF segment's qualifier element across transaction sets. There is no
// single canonical source for this list; it is the union of the previous
// hand-picked REF01 subset (header-segments.ts), the 856-specific REF01 list
// in reference/session/856-ship-notice-manifest-qualifiers-txt.md, and the
// 855-specific REF01 list in
// reference/session/855-purchase-order-acknowledgment-qualifiers-txt.md, and
// is the canonical list going forward.

import type {CodeListEntry} from './types';

export const REFERENCE_IDENTIFICATION_QUALIFIER_CODES: CodeListEntry[] = [
  {code: 'DP', label: 'Department Number'},
  {code: '19', label: 'Division Identifier'},
  {code: 'IA', label: 'Internal Vendor Number'},
  {code: 'CO', label: 'Customer Order Number'},
  {code: 'VN', label: 'Vendor Order Number'},
  {code: 'VR', label: 'Vendor ID Number'},
  {code: 'PO', label: 'Purchase Order Number'},
  {code: 'BM', label: 'Bill of Lading Number'},
  {code: 'CN', label: "Carrier's Reference Number (PRO/Invoice)"},
  {code: '2I', label: 'Tracking Number'},
  {code: 'PK', label: 'Packing List Number'},
  {code: 'MA', label: 'Ship Notice/Manifest Number'},
  {code: 'CM', label: "Buyer's Credit Memo"},
  {code: 'RZ', label: 'Returned Goods Authorization Number'},
  {code: 'QJ', label: 'Return Material Authorization Number'},
  {code: 'SI', label: "Shipper's Identifying Number for Shipment (SID)"},
  {code: 'IV', label: "Seller's Invoice Number"},
  {code: 'SN', label: 'Seal Number'},
  {code: 'LT', label: 'Lot Number'},
  {code: 'AO', label: 'Appointment Number'},
  {code: 'IT', label: 'Internal Customer Number'},
  {code: '11', label: 'Account Number'},
  {code: 'CT', label: 'Contract Number'},
  {code: 'Q1', label: 'Quote Number'},
  {code: 'PD', label: 'Promotion/Deal Number'},
  {code: 'RQ', label: 'Purchase Requisition Number'},
  {code: 'EU', label: "End User's Purchase Order Number"},
  {code: 'CR', label: 'Customer Reference Number'},
  {code: 'AN', label: 'Associated Purchase Orders'},
  {code: 'DI', label: 'Distributor Invoice Number'},
  {code: 'AH', label: 'Agreement Number'},
  {code: 'F8', label: 'Original Reference Number'},
  {code: 'P8', label: 'Pickup Reference Number'},
  {code: 'WY', label: 'Waybill Number'},
  {code: 'LO', label: 'Load Planning Number'},
  {code: 'ZZ', label: 'Mutually Defined'},
];
